import React, { useState, useEffect, useRef } from 'react'
import { toast } from 'react-toastify'
import { useSelector, useDispatch } from 'react-redux'
import { CreatorsAnchors } from '../../../../store/ducks/anchors'

import api from '../../../../services/api'
import { getPermissions } from '../../../../services/auth'
import { useHistory } from 'react-router'

import Render from './RegisterRender'

function Register ({ id }) {
  const history = useHistory()

  const [inputs, setInputs] = useState({})
  const [getErros, setErros] = useState([])
  const [getLoading, setLoading] = useState(true)

  const dispatch = useDispatch()
  const { lastGrid, filters } = useSelector(state => state.anchors)

  const ancorasLojasCodigosRef = useRef()

  const [getAncorasLojasCodigos, setAncorasLojasCodigos] = useState([])
  const [getAncorasLoadingCodigos, setAncorasLoadingCodigos] = useState(true)

  const handleInputChange = (event) => {
    event.persist()
    setInputs(inputs => ({ ...inputs, [event.target.name]: event.target.value }))
  }

  const getInfoForForm = async () => {
    try {
      const findAncoraLoja = await api.get(`AncorasLojas/ConsultarId?id=${id}`)
      setInputs(findAncoraLoja.data.resposta)
      dispatch(CreatorsAnchors.changeLastAnchorStore(findAncoraLoja.data.resposta.nome))
    } catch (err) {
      if (err.response.data && err.response.data.resposta[0]) {
        toast.error(err.response.data.resposta[0].message)
      } else {
        toast.error('Detectamos um problema interno! tente novamente em instantes.')
      }
    }
    setLoading(false)
  }

  useEffect(() => {
    if (lastGrid !== 'ancoras-lojas-codigos') {
      dispatch(CreatorsAnchors.changeLastGrid('ancoras-lojas'))
    }
    const permissions = getPermissions({ moduloId: 1344, permissao: 'Alterar' })

    if (permissions) {
      getInfoForForm()
    } else {
      history.push('/app')
    }
  }, [])

  const handleSubmit = async (event) => {
    if (event) {
      event.preventDefault()
      setLoading(true)
      try {
        const response = await api.put('AncorasLojas', { ...inputs, dataRegistro: undefined })
        if (response.data.status !== 'Inconsistencia') {
          setInputs({
            ...inputs,
            dataAtualizacao: response.data.resposta.dataAtualizacao
          })

          toast.success('Loja alterada com sucesso!')
        } else {
          if (response.data.resposta[0].key) {
            const errosArray = []

            response.data.resposta.map(resposta => {
              errosArray.push(resposta.key)

              toast.error(resposta.key + ' - ' + resposta.message)
              return null
            })

            setErros(errosArray)
          } else {
            toast.error('Não foi possível alterar a loja!')
          }
        }
      } catch (err) {
        if (err.response.data && err.response.data.resposta[0]) {
          toast.error(err.response.data.resposta[0].message)
        } else {
          toast.error('Detectamos um problema interno! tente novamente em instantes.')
        }
      }
      setLoading(false)
    }
  }

  async function findAllAncorasLojasCodigos () {
    setAncorasLoadingCodigos(true)
    try {
      const anchorFilter = filters.find(x => x.anchor === 'ancoras-lojas-codigos')

      const response = await api.get(`AncorasLojasCodigos/ConsultarAncoraLojaId?id=${id}${anchorFilter.filter ? `&status=${anchorFilter.filter}` : ''}`)
      setAncorasLojasCodigos(response.data.resposta)
    } catch (err) {
      if (err.response.data && err.response.data.resposta[0]) {
        toast.error(err.response.data.resposta[0].message)
      } else {
        toast.error('Detectamos um problema interno! tente novamente em instantes.')
      }
    }
    setAncorasLoadingCodigos(false)
  }

  useEffect(() => {
    if (!getLoading) {
      if (lastGrid === 'ancoras-lojas-codigos') {
        dispatch(CreatorsAnchors.changeLastGrid('ancoras-lojas'))
        findAllAncorasLojasCodigos()
        ancorasLojasCodigosRef.current.scrollIntoView({ behavior: 'smooth' })
      }
    }
  }, [getLoading])

  return <Render
    inputs={inputs}
    getLoading={getLoading}
    handleInputChange={handleInputChange}
    getErros={getErros}
    setErros={setErros}
    onSubmit={handleSubmit}
    ancoralojaid={id}
    findAllAncorasLojasCodigos={findAllAncorasLojasCodigos}
    getAncorasLojasCodigos={getAncorasLojasCodigos}
    getAncorasLoadingCodigos={getAncorasLoadingCodigos}
    ancorasLojasCodigosRef={ancorasLojasCodigosRef}
    lastGrid={lastGrid}
  />
}

export default Register
